/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Free Shipping Threshold — Multi-Currency Fix
 *
 * Shopify's Liquid compares cart.total_price (presentment currency) against the
 * threshold setting (base currency). This corrects the comparison client-side
 * using Shopify.currency.rate so it works for all currencies.
 */
(function () {
  function formatPresentmentMoney(cents) {
    var isoCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat('en', {
        style: 'currency',
        currency: isoCurrency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      try {
        return new Intl.NumberFormat('en', {
          style: 'currency',
          currency: isoCurrency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (e2) {
        return amount.toFixed(2);
      }
    }
  }

  function updateFreeShippingNotices() {
    var rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
      ? parseFloat(window.Shopify.currency.rate) || 1
      : 1;

    // No correction needed when viewing in the store's base currency
    if (rate === 1) return;

    document.querySelectorAll('[data-free-shipping-threshold]').forEach(function (container) {
      var thresholdBaseCents = parseInt(container.getAttribute('data-free-shipping-threshold'), 10);
      var cartTotalCents = parseInt(container.getAttribute('data-cart-total'), 10);
      var thresholdCents = Math.round(thresholdBaseCents * rate);

      var achievedEl = container.querySelector('[data-free-shipping-achieved]');
      var remainingEl = container.querySelector('[data-free-shipping-remaining]');
      if (!achievedEl || !remainingEl) return;

      if (cartTotalCents >= thresholdCents) {
        achievedEl.style.display = '';
        remainingEl.style.display = 'none';
      } else {
        achievedEl.style.display = 'none';
        remainingEl.style.display = '';

        var remainingCents = thresholdCents - cartTotalCents;
        var amountEl = remainingEl.querySelector('[data-free-shipping-remaining-amount]');
        if (amountEl) {
          amountEl.textContent = formatPresentmentMoney(remainingCents);
        }
      }
    });
  }

  // Correct on initial page load
  document.addEventListener('DOMContentLoaded', updateFreeShippingNotices);

  // Re-correct after the cart drawer re-renders its .Cart element
  document.addEventListener('DOMContentLoaded', function () {
    var sidebarCart = document.getElementById('sidebar-cart');
    if (!sidebarCart) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node.nodeType === 1 && node.classList && node.classList.contains('Cart')) {
              updateFreeShippingNotices();
              return;
            }
          }
        }
      }
    });

    // Observe direct children of #sidebar-cart for .Cart replacement
    observer.observe(sidebarCart, { childList: true });
  });
})();